export const VENDING_GETVENDINGMACHINES_LOADING =
  'VENDING_GETVENDINGMACHINES_LOADING';
export const VENDING_GETVENDINGMACHINES_SUCCESS =
  'VENDING_GETVENDINGMACHINES_SUCCESS';
export const VENDING_GETVENDINGMACHINES_ERROR =
  'VENDING_GETVENDINGMACHINES_ERROR';

export const VENDING_POSTVENDINGMACHINE_LOADING =
  'VENDING_POSTVENDINGMACHINE_LOADING';
export const VENDING_POSTVENDINGMACHINE_SUCCESS =
  'VENDING_POSTVENDINGMACHINE_SUCCESS';
export const VENDING_POSTVENDINGMACHINE_ERROR =
  'VENDING_POSTVENDINGMACHINE_ERROR';

export const VENDING_POSTDELETEVENDINGMACHINE_LOADING =
  'VENDING_POSTDELETEVENDINGMACHINE_LOADING';
export const VENDING_POSTDELETEVENDINGMACHINE_SUCCESS =
  'VENDING_POSTDELETEVENDINGMACHINE_SUCCESS';
export const VENDING_POSTDELETEVENDINGMACHINE_ERROR =
  'VENDING_POSTDELETEVENDINGMACHINE_ERROR';



// WEBPACK FOOTER //
// ./src/pages/vendingsetup/state/types.js